// removed by extract-text-webpack-plugin
module.exports = {"NavigationItems":"NavigationItems__NavigationItems__3HY9i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/NavigationItems.css
// module id = 143
// module chunks = 3